import api from './api';

export interface SubscriptionStatusPayments {
  tier: 'free' | 'pro' | 'premium';
  status: 'trialing' | 'active' | 'past_due' | 'cancelled' | null;
  trial_expires_at: string | null;
  trial_exhausted: boolean;
  plan: 'pro' | 'premium' | null;
}

export interface PaymentInitResponse {
  url: string;
  reference: string;
}

const subscriptionService = {
  /** Fetch current user's subscription state from the payments service (via backend proxy). */
  getStatus: (): Promise<SubscriptionStatusPayments> =>
    api.request<SubscriptionStatusPayments>('/api/v1/subscriptions/status'),

  /** Cancel the user's active subscription. */
  cancel: (): Promise<{ cancelled: boolean; access_until: string | null }> =>
    api.request('/api/v1/subscriptions/cancel', { method: 'POST' }),

  /**
   * Initialize a new subscription (first-time).
   * Returns a PayStack hosted payment URL + reference.
   */
  initialize: (plan: 'pro' | 'premium'): Promise<PaymentInitResponse> =>
    api.request<PaymentInitResponse>('/api/v1/subscriptions/initialize', {
      method: 'POST',
      body: JSON.stringify({ plan }),
      headers: { 'Content-Type': 'application/json' },
    }),

  /**
   * Get a re-upgrade payment URL for users with trial_exhausted=true.
   * Returns a PayStack hosted payment URL + reference.
   */
  getUpgradeUrl: (plan: 'pro' | 'premium'): Promise<PaymentInitResponse> =>
    api.request<PaymentInitResponse>(`/api/v1/subscriptions/upgrade-url?plan=${plan}`),
};

export default subscriptionService;
